<template>
  <div id="Dashboard" class="Dashboard">
    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>
      <a-row>
        <a-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
          <div class="demo-col">
            <fish-card color="blue" style="width: 100% !important">
              <div slot="header">
                <strong>SMS HÔM NAY</strong>
              </div>
              <a-row>
                <a-col :span="6">
                  <img width="60px" src="../assets/sms.png" />
                </a-col>
                <a-col :span="18" style="height: 60px; padding-top: 5px">
                  <b style="color: black; font-size: 4vh">{{
                    SMSToday | toNumber
                    }}</b>
                  <b style="color: black; font-size: 2.5vh">/</b>
                  <b style="color: black; font-size: 2.5vh">{{
                    SMS | toNumber
                    }}</b>
                </a-col>
              </a-row>
            </fish-card>
          </div>
        </a-col>
        <a-col :xs="24" :sm="7" :md="7" :lg="7" :xl="7">
          <div class="demo-col">
            <fish-card color="green" style="width: 100% !important">
              <div slot="header">
                <strong>CODE ĐÃ SỬ DỤNG</strong>
              </div>
              <a-row>
                <a-col :span="6">
                  <img width="60px" src="../assets/code.png" />
                </a-col>
                <a-col :span="18" style="height: 60px; padding-top: 5px">
                  <b style="color: black; font-size: 4vh">{{
                    UsedCodeToday | toNumber
                    }}</b>

                  <b style="color: black; font-size: 2.5vh">/</b>
                  <b style="color: black; font-size: 2.5vh">{{
                    UsedCode | toNumber
                    }}</b>
                </a-col>
              </a-row>
            </fish-card>
          </div>
        </a-col>
        <a-col :xs="24" :sm="5" :md="5" :lg="5" :xl="5">
          <div class="demo-col demo-col2">
            <fish-card color="yellow" style="width: 100% !important">
              <div slot="header">
                <strong>QUÁ {{ this.$PRJ_DAY_TOPUP }} TOPUP/NGÀY</strong>
              </div>
              <a-row>
                <a-col :span="9">
                  <img width="60px" src="../assets/block.png" />
                </a-col>
                <a-col :span="15" style="height: 60px; padding-top: 5px">
                  <b style="color: black; font-size: 4vh">{{ BlockList }}</b>
                </a-col>
              </a-row>
            </fish-card>
          </div>
        </a-col>
        <a-col :xs="24" :sm="5" :md="5" :lg="5" :xl="5">
          <div class="demo-col">
            <fish-card color="red" style="width: 100% !important">
              <div slot="header">
                <strong>QUÁ {{ this.$PRJ_MAX_TOPUP }} TOPUP/C.T</strong>
              </div>
              <a-row>
                <a-col :span="9">
                  <img width="60px" src="../assets/blacklist.png" />
                </a-col>
                <a-col :span="14" style="height: 60px; padding-top: 5px">
                  <b style="color: black; font-size: 4vh">{{ BlackList }}</b>
                </a-col>
              </a-row>
            </fish-card>
          </div>
        </a-col>
      </a-row>
      <hr />
      <fish-row>
        <fish-col span="24" class="text-left">
          <h1>
            <b>BÁO CÁO {{ TIME }}: {{ TimeString }}</b>
          </h1>
        </fish-col>
      </fish-row>
      <fish-row>
        <fish-col span="12">
          <fish-row>
            <fish-col span="14">
              <fish-card fluid>
                <div slot="header">
                  <strong>TỔNG SỐ</strong>
                </div>

                <fish-row>
                  <fish-col span="24">
                    <!-- <a-progress :percent="30" /> -->
                    <vm-progress :percentage="report.TIMECount_Percent" :text-inside="true" :stroke-width="14"
                      status="info" :striped="true">Số lượng: {{ report.TIMECount | toNumber }}</vm-progress>
                    <vm-progress v-if="this.$PRJ_IS_30K == true" :percentage="report.TIMEMoney30K_Percent"
                      :text-inside="true" :stroke-width="14" status="warning" :striped="true">Tổng 30K: {{
                        report.TIME30K |
                      toNumber }} | {{
                        report.TIMEMoney30K | toCurrency }}</vm-progress>
                    <vm-progress v-if="this.$PRJ_IS_20K == true" :percentage="report.TIMEMoney20K_Percent"
                      :text-inside="true" :stroke-width="14" status="warning" :striped="true">Tổng 20K: {{
                        report.TIME20K |
                      toNumber }} | {{
                        report.TIMEMoney20K | toCurrency }}</vm-progress>
                    <vm-progress :percentage="report.ALLPercent" :text-inside="true" :stroke-width="14" status="success"
                      :striped="true">TỔNG SỐ LƯỢNG: {{ UsedCode | toNumber }}</vm-progress>
                    <vm-progress :percentage="report.ALLMoney_Percent" :text-inside="true" :stroke-width="14"
                      status="success" :striped="true">TỔNG SỐ TIỀN:
                      {{ report.ALLMoney | toCurrency }}</vm-progress>
                  </fish-col>
                  <fish-col span="6">
                    <div class="circlePercent">
                      {{ parseFloat(report.ALLPercent.toString()).toFixed(1) }}%
                    </div>
                    <!-- <a-progress type="circle" :width="55" :percent="report.ALLPercent" /> -->
                  </fish-col>
                </fish-row>
              </fish-card>
            </fish-col>
            <fish-col span="10">
              <fish-card fluid color="yellow">
                <div slot="header">
                  <strong>PHÂN LOẠI</strong>
                </div>

                <fish-row>
                  <fish-col span="24">
                    <!-- <a-progress :percent="30" /> -->
                    <vm-progress :percentage="report.TIMEWEB_Percent" :text-inside="true" :stroke-width="14"
                      status="info" style="taxt-align: left !important" :striped="true">WEB: {{ report.TIMEWEB |
                      toNumber }} |
                      {{ report.TIMEWEB_Money | toCurrency }}
                    </vm-progress>
                    <vm-progress :percentage="report.TIMESMS_Percent" :text-inside="true" :stroke-width="14"
                      status="info" style="taxt-align: left !important" :striped="true">SMS: {{ report.TIMESMS |
                      toNumber }} |
                      {{ report.TIMESMS_Money | toCurrency }}
                    </vm-progress>
                    <vm-progress :percentage="report.ALLWEB_Percent" :text-inside="true" :stroke-width="14"
                      status="success" style="taxt-align: left !important" :striped="true">TỔNG WEB: {{ report.ALLWEB |
                      toNumber }} |
                      {{ report.ALLWEB_Money | toCurrency }}
                    </vm-progress>
                    <vm-progress :percentage="report.ALLSMS_Percent" :text-inside="true" :stroke-width="14"
                      status="success" style="taxt-align: left !important" :striped="true">TỔNG SMS: {{ report.ALLSMS |
                      toNumber }} |
                      {{ report.ALLSMS_Money | toCurrency }}
                    </vm-progress>
                    <div v-if="this.$PRJ_IS_30K == true && this.$PRJ_IS_20K == true" style="height: 19px;"></div>
                  </fish-col>
                </fish-row>
              </fish-card>
            </fish-col>
          </fish-row>
        </fish-col>
        <fish-col span="12">
          <a-row type="flex" align="middle">
            <a-col :xs="24" :sm="8" :md="8" :lg="8">
              <fish-card color="blue" fluid>
                <div slot="header">
                  <strong>VIETTEL</strong>
                </div>
                <vm-progress :percentage="report.VTELCount_Percent" :text-inside="true" :stroke-width="14"
                  status="success" :striped="true">Số lượng: {{ report.VTELCount | toNumber }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_30K == true" :percentage="report.VTELMoney30K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">30K: {{ report.VTELMoney30K |
                    toCurrency
                  }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_20K == true" :percentage="report.VTELMoney20K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">20K: {{ report.VTELMoney20K |
                    toCurrency
                  }}</vm-progress>
                <div>
                  <a-spin :spinning="isLoadingPaid" size="small" tip="Đang tải...">
                    <!-- <fish-loader :active="isLoadingPaid"></fish-loader> -->
                    <vm-progress :percentage="report.VTEL_PREPAID" :text-inside="true" :stroke-width="14" status="info"
                      :striped="true">Trả trước:
                      {{ report.VTEL_PREPAID_MONEY | toCurrency }}</vm-progress>
                    <vm-progress :percentage="report.VTEL_POSTPAID" :text-inside="true" :stroke-width="14" status="info"
                      :striped="true">Trả sau:
                      {{ report.VTEL_POSTPAID_MONEY | toCurrency }}</vm-progress>
                  </a-spin>
                </div>
              </fish-card>
            </a-col>
            <a-col :xs="24" :sm="8" :md="8" :lg="8">
              <fish-card color="blue" fluid>
                <div slot="header">
                  <strong>MOBI</strong>
                </div>
                <vm-progress :percentage="report.MOBICount_Percent" :text-inside="true" :stroke-width="14"
                  status="success" :striped="true">Số lượng: {{ report.MOBICount | toNumber }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_30K == true" :percentage="report.MOBIMoney30K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">30K: {{ report.MOBIMoney30K |
                    toCurrency
                  }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_20K == true" :percentage="report.MOBIMoney20K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">20K: {{ report.MOBIMoney20K |
                    toCurrency
                  }}</vm-progress>

                <div>
                  <a-spin :spinning="isLoadingPaid" size="small" tip="Đang tải...">
                    <vm-progress :percentage="report.MOBI_PREPAID" :text-inside="true" :stroke-width="14" status="info"
                      :striped="true">Trả trước:
                      {{ report.MOBI_PREPAID_MONEY | toCurrency }}</vm-progress>
                    <vm-progress :percentage="report.MOBI_POSTPAID" :text-inside="true" :stroke-width="14" status="info"
                      :striped="true">Trả sau:
                      {{ report.MOBI_POSTPAID_MONEY | toCurrency }}</vm-progress>
                  </a-spin>
                </div>
              </fish-card>
            </a-col>
            <a-col :xs="24" :sm="8" :md="8" :lg="8">
              <fish-card color="blue" fluid>
                <div slot="header">
                  <strong>VINA</strong>
                </div>
                <vm-progress :percentage="report.VINACount_Percent" :text-inside="true" :stroke-width="14"
                  status="success" :striped="true">Số lượng: {{ report.VINACount | toNumber }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_30K == true" :percentage="report.VINAMoney30K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">30K: {{ report.VINAMoney30K |
                    toCurrency
                  }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_20K == true" :percentage="report.VINAMoney20K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">20K: {{ report.VINAMoney20K |
                    toCurrency
                  }}</vm-progress>
                <div>
                  <a-spin :spinning="isLoadingPaid" size="small" tip="Đang tải...">
                    <vm-progress :percentage="report.VINA_PREPAID" :text-inside="true" :stroke-width="14" status="info"
                      :striped="true">Trả trước:
                      {{ report.VINA_PREPAID_MONEY | toCurrency }}</vm-progress>
                    <vm-progress :percentage="report.VINA_POSTPAID" :text-inside="true" :stroke-width="14" status="info"
                      :striped="true">Trả sau:
                      {{ report.VINA_POSTPAID_MONEY | toCurrency }}</vm-progress>
                  </a-spin>
                </div>
              </fish-card>
            </a-col>
            <!-- <a-col :xs="24" :sm="6" :md="6" :lg="6">
              <fish-card color="blue" fluid>
                <div slot="header">
                  <strong>MẠNG KHÁC</strong>
                </div>
                <vm-progress :percentage="report.MKHACCount_Percent" :text-inside="true" :stroke-width="14"
                  status="success" :striped="true">Số lượng: {{ report.MKHACCount | toNumber }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_30K == true" :percentage="report.MKHACMoney30K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">30K: {{ report.MKHACMoney30K |
                    toCurrency
                  }}</vm-progress>
                <vm-progress v-if="this.$PRJ_IS_20K == true" :percentage="report.MKHACMoney20K_Percent"
                  :text-inside="true" :stroke-width="14" status="success" :striped="true">20K: {{ report.MKHACMoney20K |
                    toCurrency
                  }}</vm-progress>
                <div>
                  <a-spin :spinning="isLoadingPaid" size="small" tip="Đang tải...">
                    <vm-progress :percentage="report.MKHAC_PREPAID" :text-inside="true" :stroke-width="14" status="info"
                      :striped="true">Trả trước:
                      {{ report.MKHAC_PREPAID_MONEY | toCurrency }}</vm-progress>
                    <vm-progress :percentage="report.MKHAC_POSTPAID" :text-inside="true" :stroke-width="14"
                      status="info" :striped="true">Trả sau:
                      {{ report.MKHAC_POSTPAID_MONEY | toCurrency }}</vm-progress>
                  </a-spin>
                </div>
              </fish-card>
            </a-col> -->
            <!-- <a-col :xs="24" :sm="5" :md="5" :lg="5">
              <fish-card color="blue" fluid>
                <div slot="header">
                  <strong>VNMB</strong>
                </div>
                <vm-progress
                  :percentage="report.VNMBCount_Percent"
                  :text-inside="true"
                  :stroke-width="14"
                  status="success"
                  :striped="true"
                  >Số lượng: {{ report.VNMBCount | toNumber }}</vm-progress
                >
                <vm-progress  v-if="this.$PRJ_IS_30K==true"
                  :percentage="report.VNMBMoney30K_Percent"
                  :text-inside="true"
                  :stroke-width="14"
                  status="success"
                  :striped="true"
                  >30K: {{ report.VNMBMoney30K | toCurrency }}</vm-progress
                >
                <vm-progress  v-if="this.$PRJ_IS_20K==true"
                  :percentage="report.VNMBMoney20K_Percent"
                  :text-inside="true"
                  :stroke-width="14"
                  status="success"
                  :striped="true"
                  >20K: {{ report.VNMBMoney20K | toCurrency }}</vm-progress
                >
                <div>
                  <a-spin
                    :spinning="isLoadingPaid"
                    size="small"
                    tip="Đang tải..."
                  >
                    <vm-progress
                      :percentage="report.VNMB_PREPAID"
                      :text-inside="true"
                      :stroke-width="14"
                      status="info"
                      :striped="true"
                      >Trả trước:
                      {{ report.VNMB_PREPAID_MONEY | toCurrency }}</vm-progress
                    >
                    <vm-progress
                      :percentage="report.VNMB_POSTPAID"
                      :text-inside="true"
                      :stroke-width="14"
                      status="info"
                      :striped="true"
                      >Trả sau:
                      {{ report.VNMB_POSTPAID_MONEY | toCurrency }}</vm-progress
                    >
                  </a-spin>
                </div>
              </fish-card>
            </a-col>
            <a-col :xs="24" :sm="4" :md="4" :lg="4">
              <fish-card color="blue" fluid>
                <div slot="header">
                  <strong>GTEL</strong>
                </div>
                <vm-progress
                  :percentage="report.GTELCount_Percent"
                  :text-inside="true"
                  :stroke-width="14"
                  status="success"
                  :striped="true"
                  >Số lượng: {{ report.GTELCount | toNumber }}</vm-progress
                >
                <vm-progress  v-if="this.$PRJ_IS_30K==true"
                  :percentage="report.GTELMoney30K_Percent"
                  :text-inside="true"
                  :stroke-width="14"
                  status="success"
                  :striped="true"
                  >30K: {{ report.GTELMoney30K | toCurrency }}</vm-progress
                >
                <vm-progress  v-if="this.$PRJ_IS_20K==true"
                  :percentage="report.GTELMoney20K_Percent"
                  :text-inside="true"
                  :stroke-width="14"
                  status="success"
                  :striped="true"
                  >20K: {{ report.GTELMoney20K | toCurrency }}</vm-progress
                >
                <div>
                  <a-spin
                    :spinning="isLoadingPaid"
                    size="small"
                    tip="Đang tải..."
                  >
                    <vm-progress
                      :percentage="report.GTEL_PREPAID"
                      :text-inside="true"
                      :stroke-width="14"
                      status="info"
                      :striped="true"
                      >Trả trước:
                      {{ report.GTEL_PREPAID_MONEY | toCurrency }}</vm-progress
                    >
                    <vm-progress
                      :percentage="report.GTEL_POSTPAID"
                      :text-inside="true"
                      :stroke-width="14"
                      status="info"
                      :striped="true"
                      >Trả sau:
                      {{ report.GTEL_POSTPAID_MONEY | toCurrency }}</vm-progress
                    >
                  </a-spin>
                </div>
              </fish-card>
            </a-col> -->
          </a-row>
        </fish-col>
      </fish-row>
      <div style="text-align: left">
        <i>
          <b>Lưu ý:</b> Dữ liệu tỷ lệ tổng dự án được tính theo % công thức: (
          <b>[Số lượng topup thực tế] / [Số lượng topup trên hợp đồng]</b>)
        </i>
      </div>
      <fish-row>
        <fish-col span="24">
          <apexchart id="vuechart-example" width="100%" height="300px" :type="chartType" :options="options"
            :series="series"></apexchart>
        </fish-col>
      </fish-row>
      <fish-row>
        <fish-col span="24">
          <!-- <fish-table :columns="TBLcolumns" :data="TBLdata" noMoreText="Không có dữ liệu"></fish-table> -->

          <a-table rowKey="index" size="small" :columns="TBLcolumns" :data-source="TBLdata" :pagination="false"
            :scroll="{ x: 750 }">
            >
            <template slot="VTEL" slot-scope="text">{{
              text | toCurrency
              }}</template>
            <template slot="MOBI" slot-scope="text">{{
              text | toCurrency
              }}</template>
            <template slot="VINA" slot-scope="text">{{
              text | toCurrency
            }}</template>
            <template slot="MKHAC" slot-scope="text">{{
              text | toCurrency
            }}</template>
            <template slot="VNMB" slot-scope="text">{{
              text | toCurrency
            }}</template>
            <template slot="GTEL" slot-scope="text">{{
              text | toCurrency
            }}</template>
            <template slot="Total" slot-scope="text">{{
              text | toNumber
            }}</template>
            <template slot="Value" slot-scope="text">{{
              text | toCurrency
            }}</template>
          </a-table>
        </fish-col>
      </fish-row>
    </fish-segment>
  </div>
</template>

<script>
function toCurrency(value) {
  if (typeof value !== "number") {
    return value;
  }
  var formatter = new Intl.NumberFormat("vi-VN", {
    style: "currency",
    currency: "VND",
    minimumFractionDigits: 0,
  });
  return formatter.format(value);
}
import { mapActions } from "vuex";
import moment from "moment";
import axios from "axios";
export default {
  name: "DashBoard",
  props: {
    TIME: String,
  },
  components: {},
  data() {
    let sCate = [];
    let dateFrom = null;
    let dateTo = null;
    let TimeStr = "";
    let ChartType = "line";
    if (this.TIME == "7 NGÀY GẦN NHẤT") {
      dateFrom = moment().add(-7, "days");
      if (dateFrom.diff(moment(this.$PRJ_START_DATE), "days") < 0) {
        dateFrom = moment(this.$PRJ_START_DATE);
      }
      dateTo = moment().add(-1, "days");
      if (moment().diff(moment(this.$PRJ_START_DATE), "days") < 0) {
        ChartType = "bar";
        dateFrom = moment();
        dateTo = moment();
      }
      TimeStr =
        " Từ " +
        moment(dateFrom).format("DD/MM/YYYY") +
        " đến " +
        moment(dateTo).format("DD/MM/YYYY");
    } else if (this.TIME == "TOÀN BỘ") {
      dateFrom = moment(this.$PRJ_START_DATE);

      if (moment().diff(moment(this.$PRJ_START_DATE), "days") < 0) {
        ChartType = "bar";
        dateFrom = moment();
      }
      dateTo = moment();
      TimeStr =
        " Từ " +
        moment(dateFrom).format("DD/MM/YYYY") +
        " đến " +
        moment(dateTo).format("DD/MM/YYYY");
    } else {
      ChartType = "bar";
      dateFrom = moment();
      dateTo = moment();
      TimeStr = moment(dateFrom).format("DD/MM/YYYY");
    }
    let dateDiff = dateTo.diff(dateFrom, "days");
    let dateRange = 1;
    if (dateDiff >= 15 && dateDiff <= 25) dateRange = 4;
    else if (dateDiff > 25) dateRange = 7;
    let i = 0;
    for (
      var CurrDate = moment(dateFrom);
      CurrDate.diff(dateTo, "days") <= 0;
      CurrDate.add(1, "days")
    ) {
      if (
        moment(CurrDate).format("DD/MM/YYYY 00:00:00") ==
        moment(dateFrom).format("DD/MM/YYYY 00:00:00")
      ) {
        sCate.push(CurrDate.format("DD/MM"));
      } else if (++i == dateRange) {
        i = 0;
        sCate.push(CurrDate.format("DD/MM"));
      } else {
        sCate.push("");
      }
    }
    if (sCate[sCate.length - 2] == "") {
      sCate[sCate.length - 2] = dateTo.format("DD/MM");
    }
    return {
      // PRJ_DATA:{

      // },
      UsedCode: 0,
      UsedCodeToday: 0,
      BlockList: 0,
      BlackList: 0,
      SMS: 0,
      SMSToday: 0,
      Timer: 0,
      chartType: ChartType,
      isLoading: false,
      isLoadingPaid: false,
      TimeString: TimeStr,
      report: {

        //Thông tin Tổng số
        TIMECount_Percent: 0,
        TIMECount: 0,
        TIMEMoney30K_Percent: 0,
        TIMEMoney30K: 0,
        TIMEMoney20K_Percent: 0,
        TIMEMoney20K: 0,
        TIME30K: 0,
        TIME20K: 0,

        TIMEWEB: 0,
        TIMEWEB_Percent: 0,
        TIMESMS: 0,
        TIMESMS_Percent: 0,
        TIMEWEB_Money: 0,
        TIMESMS_Money: 0,

        ALLWEB: 0,
        ALLWEB_Percent: 0,
        ALLSMS: 0,
        ALLSMS_Percent: 0,
        ALLWEB_Money: 0,
        ALLSMS_Money: 0,

        ALLPercent: 0,
        ALLMoney_Percent: 0,
        ALLMoney: 0,
        //Thông tin theo nhà mạng
        VTELCount_Percent: 0,
        VTELCount: 0,
        VTELMoney30K_Percent: 0,
        VTELMoney30K: 0,
        VTELMoney20K_Percent: 0,
        VTELMoney20K: 0,

        MOBICount_Percent: 0,
        MOBICount: 0,
        MOBIMoney30K_Percent: 0,
        MOBIMoney30K: 0,
        MOBIMoney20K_Percent: 0,
        MOBIMoney20K: 0,

        VINACount_Percent: 0,
        VINACount: 0,
        VINAMoney30K_Percent: 0,
        VINAMoney30K: 0,
        VINAMoney20K_Percent: 0,
        VINAMoney20K: 0,

        MKHACCount_Percent: 0,
        MKHACCount: 0,
        MKHACMoney30K_Percent: 0,
        MKHACMoney30K: 0,
        MKHACMoney20K_Percent: 0,
        MKHACMoney20K: 0,

        VNMBCount_Percent: 0,
        VNMBCount: 0,
        VNMBMoney30K_Percent: 0,
        VNMBMoney30K: 0,
        VNMBMoney20K_Percent: 0,
        VNMBMoney20K: 0,

        GTELCount_Percent: 0,
        GTELCount: 0,
        GTELMoney30K_Percent: 0,
        GTELMoney30K: 0,
        GTELMoney20K_Percent: 0,
        GTELMoney20K: 0,

        VTEL_PREPAID: 0,
        MOBI_PREPAID: 0,
        VINA_PREPAID: 0,
        VNMB_PREPAID: 0,
        GTEL_PREPAID: 0,
        VTEL_POSTPAID: 0,
        MOBI_POSTPAID: 0,
        VINA_POSTPAID: 0,
        VNMB_POSTPAID: 0,
        GTEL_POSTPAID: 0,

        VTEL_PREPAID_MONEY: 0,
        MOBI_PREPAID_MONEY: 0,
        VINA_PREPAID_MONEY: 0,
        VNMB_PREPAID_MONEY: 0,
        GTEL_PREPAID_MONEY: 0,
        VTEL_POSTPAID_MONEY: 0,
        MOBI_POSTPAID_MONEY: 0,
        VINA_POSTPAID_MONEY: 0,
        VNMB_POSTPAID_MONEY: 0,
        GTEL_POSTPAID_MONEY: 0,
      },
      TBLcolumns: [
        {
          title: "#",
          dataIndex: "index",
          key: "index",
          align: "center",
          scopedSlots: {
            customRender: "index",
          },
          fixed: "left",
          width: 40,
        },
        {
          title: "DATE",
          dataIndex: "Date",
          key: "Date",
          align: "center",
          fixed: "left",
          width: 90,
        },
        {
          title: "VTEL",
          dataIndex: "VTEL",
          key: "VTEL",
          align: "center",
          scopedSlots: {
            customRender: "VTEL",
          },
          width: 90,
        },
        {
          title: "MOBI",
          dataIndex: "MOBI",
          key: "MOBI",
          align: "center",
          scopedSlots: {
            customRender: "MOBI",
          },
          width: 90,
        },
        {
          title: "VINA",
          dataIndex: "VINA",
          key: "VINA",
          align: "center",
          scopedSlots: {
            customRender: "VINA",
          },
          width: 90,
        },
        // {
        //   title: "MẠNG KHÁC",
        //   dataIndex: "MKHAC",
        //   key: "MKHAC",
        //   align: "center",
        //   scopedSlots: {
        //     customRender: "MKHAC",
        //   },
        //   width: 90,
        // },
        // {
        //   title: "GTEL",
        //   dataIndex: "GTEL",
        //   key: "GTEL",
        //   align: "center",
        //   scopedSlots: {
        //     customRender: "GTEL",
        //   },
        //   width: 90,
        // },
        {
          title: "TOTAL",
          dataIndex: "Total",
          key: "Total",
          align: "center",
          scopedSlots: {
            customRender: "Total",
          },
          width: 70,
        },
        {
          title: "VALUE",
          dataIndex: "Value",
          key: "Value",
          align: "center",
          scopedSlots: {
            customRender: "Value",
          },
          fixed: "right",
        },
      ],
      // TBLcolumns: [
      //   { title: "#", type: "index", width: "50", align: "center" },
      //   { title: "Date", key: "Date" },
      //   { title: "VIETTEL", key: "VTEL" },
      //   { title: "MOBI", key: "MOBI" },
      //   { title: "VINA", key: "VINA" },
      //   { title: "Vietname Mobile", key: "VNMB" },
      //   { title: "GMobile", key: "GTEL" },
      //   { title: "Total", key: "Total" },
      //   { title: "Value", key: "Value" },
      // ],
      TBLdata: [],
      arrCarrier: ["VTEL", "MOBI", "VINA", "VNMB", "GTEL"],
      arrAward: [30000, 20000],
      arrPaytype: ["PREPAID", "POSTPAID"],
      datacollection: null,
      options: {
        chart: {
          id: "vuechart-example",
        },
        xaxis: {
          categories: sCate,
        },
        dataLabels: {
          enabled: false,
          enabledOnSeries: true,
          formatter: function (val) {
            return toCurrency(val);
          },
        },
        yaxis: {
          show: true,
          showAlways: true,
          labels: {
            show: true,
            align: "right",
            minWidth: 0,
            maxWidth: 160,
            style: {
              colors: [],
              fontSize: "12px",
              fontFamily: "Helvetica, Arial, sans-serif",
              fontWeight: 400,
              cssClass: "apexcharts-yaxis-label",
            },
            offsetX: 0,
            offsetY: 0,
            rotate: 0,
            formatter: (value) => {
              return toCurrency(value);
            },
          },
        },
      },
      series: [
        {
          name: "Số tiền",
          data: [],
        },
      ],
    };
  },
  mounted() {
    for (let iCol = 1; iCol < this.TBLcolumns.length - 1; iCol++) {
      if (window.innerWidth > 700) {
        if ("width" in this.TBLcolumns[iCol])
          delete this.TBLcolumns[iCol].width;
      } else {
        this.TBLcolumns[iCol].width = 90;
      }
    }
    this.fillData();
    this.Timer = setInterval(this.fillData, 300000);
  },
  methods: {
    ...mapActions([
      "API_Report",
      "API_GetDashboard",
      "API_GetDashboard_Paytype",
    ]),
    async fillData() {
      console.log("BEGIN FILL DATA!");
      let nowTime = "";
      try {
        await axios
          .get(this.$PRJ_DOMAIN + "/api/getnowtime")
          .then((res) => {
            if (res.State == 1)
              nowTime = moment(res.Message).format("YYYY-MM-DD HH:mm:ss");
            else {
              nowTime = moment().format("YYYY-MM-DD HH:mm:ss");
            }
          });
      } catch (error) {
        nowTime = moment().format("YYYY-MM-DD HH:mm:ss");
        console.log(error.message);
      }
      // console.log("GET NEW DATA!");
      // try {
      this.isLoading = true;
      // this.datacollection = {
      //   labels: [this.getRandomInt(), this.getRandomInt()],
      //   datasets: [
      //     {
      //       label: "Data One",
      //       backgroundColor: "#f87979",
      //       data: [this.getRandomInt(), this.getRandomInt()],
      //     },
      //   ],
      // };
      let resDashboard = "";

      if (this.TIME == "HÔM NAY") {
        resDashboard = await this.API_GetDashboard({
          time: "TODAY",
          endDate: nowTime,
        });
        // [result, resDashboard] = await Promise.all([
        //   this.API_Report("TODAY"),
        //   this.API_GetDashboard(),
        // ]);
      } else if (this.TIME == "7 NGÀY GẦN NHẤT") {
        resDashboard = await this.API_GetDashboard({
          time: "LASTWEEK",
          endDate: nowTime,
        });
        // [result, resDashboard] = await Promise.all([
        //   this.API_Report("LASTWEEK"),
        //   this.API_GetDashboard(),
        // ]);
        // result = await this.API_Report("LASTWEEK");
      } else if (this.TIME == "TOÀN BỘ") {
        resDashboard = await this.API_GetDashboard({
          time: "ALL",
          endDate: nowTime,
        });
        // [result, resDashboard] = await Promise.all([
        //   this.API_Report("ALL"),
        //   this.API_GetDashboard(),
        // ]);
        // result = await this.API_Report("ALL");
      }
      // this.getPaytype(nowTime);

      if (process.env.NODE_ENV === 'development')
        console.log(resDashboard);
      if (resDashboard.data.State == 1) {
        this.SMS = resDashboard.data.Message.SMS;
        this.SMSToday = resDashboard.data.Message.SMSToday;
        this.UsedCode = resDashboard.data.Message.UsedCode;
        this.UsedCodeToday = resDashboard.data.Message.UsedCodeToday;
        this.BlockList = resDashboard.data.Message.BlockList;
        this.BlackList = resDashboard.data.Message.BlackList;
      }

      if (resDashboard.data.State == 1) {
        this.report = {
          //Thông tin Tổng số
          TIMECount_Percent: 0,
          TIMECount: 0,
          TIMEMoney30K_Percent: 0,
          TIMEMoney30K: 0,
          TIMEMoney20K_Percent: 0,
          TIMEMoney20K: 0,
          TIME30K: 0,
          TIME20K: 0,

          TIMEWEB: 0,
          TIMEWEB_Percent: 0,
          TIMESMS: 0,
          TIMESMS_Percent: 0,
          TIMEWEB_Money: 0,
          TIMESMS_Money: 0,

          ALLWEB: 0,
          ALLWEB_Percent: 0,
          ALLSMS: 0,
          ALLSMS_Percent: 0,
          ALLWEB_Money: 0,
          ALLSMS_Money: 0,

          ALLPercent: 0,
          ALLMoney_Percent: 0,
          ALLMoney: 0,
          //Thông tin theo nhà mạng
          VTELCount_Percent: 0,
          VTELCount: 0,
          VTELMoney30K_Percent: 0,
          VTELMoney30K: 0,
          VTELMoney20K_Percent: 0,
          VTELMoney20K: 0,

          MOBICount_Percent: 0,
          MOBICount: 0,
          MOBIMoney30K_Percent: 0,
          MOBIMoney30K: 0,
          MOBIMoney20K_Percent: 0,
          MOBIMoney20K: 0,

          VINACount_Percent: 0,
          VINACount: 0,
          VINAMoney30K_Percent: 0,
          VINAMoney30K: 0,
          VINAMoney20K_Percent: 0,
          VINAMoney20K: 0,

          MKHACCount_Percent: 0,
          MKHACCount: 0,
          MKHACMoney30K_Percent: 0,
          MKHACMoney30K: 0,
          MKHACMoney20K_Percent: 0,
          MKHACMoney20K: 0,

          VNMBCount_Percent: 0,
          VNMBCount: 0,
          VNMBMoney30K_Percent: 0,
          VNMBMoney30K: 0,
          VNMBMoney20K_Percent: 0,
          VNMBMoney20K: 0,

          GTELCount_Percent: 0,
          GTELCount: 0,
          GTELMoney30K_Percent: 0,
          GTELMoney30K: 0,
          GTELMoney20K_Percent: 0,
          GTELMoney20K: 0,

          VTEL_PREPAID: 0,
          MOBI_PREPAID: 0,
          VINA_PREPAID: 0,
          VNMB_PREPAID: 0,
          GTEL_PREPAID: 0,
          VTEL_POSTPAID: 0,
          MOBI_POSTPAID: 0,
          VINA_POSTPAID: 0,
          VNMB_POSTPAID: 0,
          GTEL_POSTPAID: 0,

          VTEL_PREPAID_MONEY: 0,
          MOBI_PREPAID_MONEY: 0,
          VINA_PREPAID_MONEY: 0,
          VNMB_PREPAID_MONEY: 0,
          GTEL_PREPAID_MONEY: 0,
          VTEL_POSTPAID_MONEY: 0,
          MOBI_POSTPAID_MONEY: 0,
          VINA_POSTPAID_MONEY: 0,
          VNMB_POSTPAID_MONEY: 0,
          GTEL_POSTPAID_MONEY: 0,
        };
        this.TBLdata = [];

        this.options.xaxis.categories = [];
        this.series = [
          {
            name: "Số tiền",
            data: [],
          },
        ];
        let ChartData = {
          cate: [],
          data: [],
        };
        // const DISCOUNT_DATES = Object.keys(
        //   resDashboard.data.Message.Data.Discount_History
        // ).sort();

        // function getDiscountByDate(date) {
        //   const history = resDashboard.data.Message.Data.Discount_History;

        //   let target;

        //   if (moment.isMoment(date)) {
        //     target = date;
        //   }
        //   else if (date instanceof Date) {
        //     target = moment(date);
        //   }
        //   else if (typeof date === "string") {
        //     target = moment(date, ["DD/MM/YYYY", "YYYY-MM-DD"], true);

        //     if (!target.isValid()) {
        //       throw new Error(`Invalid date: ${date}`);
        //     }
        //   }
        //   else {
        //     throw new Error(`Unsupported date type: ${typeof date}`);
        //   }

        //   let result = history[DISCOUNT_DATES[0]];

        //   for (const key of DISCOUNT_DATES) {
        //     if (target.isSameOrAfter(key, "day")) {
        //       result = history[key];
        //     } else {
        //       break;
        //     }
        //   }

        //   return result;
        // }
        // function getMoney(faceValue, carrier, date) {
        //   const discount = getDiscountByDate(date);

        //   return faceValue * (100 - discount[carrier]) / 100;
        // }
        this.report.ALLPercent =
          (resDashboard.data.Message.Data.AllTotal / this.$PRJ_CODE_AMOUNT) * 100; //7814871
        this.report.ALLMoney =
          resDashboard.data.Message.Data.AllValue_30K +
          resDashboard.data.Message.Data.AllValue_20K;
        this.report.ALLMoney_Percent =
          (this.report.ALLMoney / this.$PRJ_TOTAL_AWARD) * 100; //156297420000

        this.report.ALLWEB = resDashboard.data.Message.Data.AllWEB;
        this.report.ALLWEB_Money = resDashboard.data.Message.Data.AllWEB_30K + resDashboard.data.Message.Data.AllWEB_20K;
        this.report.ALLSMS = resDashboard.data.Message.Data.AllSMS;
        this.report.ALLSMS_Money = resDashboard.data.Message.Data.AllSMS_30K + resDashboard.data.Message.Data.AllSMS_20K;

        this.report.ALLWEB_Percent =
          (this.report.ALLWEB / (this.report.ALLWEB + this.report.ALLSMS)) *
          100;
        this.report.ALLSMS_Percent = 100 - this.report.ALLWEB_Percent;
        let count = 0;
        // let VTEL30K_Count = 0;
        // let MOBI30K_Count = 0;
        // let VINA30K_Count = 0;
        // let VNMB30K_Count = 0;
        // let GTEL30K_Count = 0;
        // let MONEY_DISCOUNT = resDashboard.data.Message.Data.MONEY_DISCOUNT;
        for (let resDate of resDashboard.data.Message.Data.Detail) {

          resDate["index"] = ++count;
          for (let oCarrier of this.arrCarrier) {
            for (let oAward of this.arrAward) {
              for (let oPaytype of this.arrPaytype) {
                this.report[oCarrier + "_" + oPaytype] +=
                  resDate[oCarrier + "_" + oAward + "_" + oPaytype];
              }
            }
          }
          for (let oCarrier of this.arrCarrier) {
            for (let oAward of this.arrAward) {
              for (let oPaytype of this.arrPaytype) {
                this.report[oCarrier + "_" + oPaytype + "_MONEY"] +=
                  resDate[oCarrier + "_" + oAward + "_" + oPaytype + "_MONEY"];
              }
            }
          }
          console.log(resDate.Date + ": PROCESSED Paytype!");

          // COUNT
          this.report.VTELCount += resDate.VTEL_30000 + resDate.VTEL_20000;
          this.report.MOBICount += resDate.MOBI_30000 + resDate.MOBI_20000;
          this.report.VINACount += resDate.VINA_30000 + resDate.VINA_20000;
          this.report.VNMBCount += resDate.VNMB_30000 + resDate.VNMB_20000;
          this.report.GTELCount += resDate.GTEL_30000 + resDate.GTEL_20000;

          this.report.MKHACCount +=
            resDate.VNMB_30000 +
            resDate.VNMB_20000 +
            resDate.GTEL_30000 +
            resDate.GTEL_20000;

          this.report.TIME30K +=
            resDate.VTEL_30000 +
            resDate.MOBI_30000 +
            resDate.VINA_30000 +
            resDate.VNMB_30000 +
            resDate.GTEL_30000;

          this.report.TIME20K +=
            resDate.VTEL_20000 +
            resDate.MOBI_20000 +
            resDate.VINA_20000 +
            resDate.VNMB_20000 +
            resDate.GTEL_20000;

          console.log(resDate.Date + ": PROCESSED Count!");
          // MONEY 30K
          this.report.VTELMoney30K += resDate.VTEL_30000_MONEY;
          this.report.MOBIMoney30K += resDate.MOBI_30000_MONEY;
          this.report.VINAMoney30K += resDate.VINA_30000_MONEY;
          this.report.VNMBMoney30K += resDate.VNMB_30000_MONEY;
          this.report.GTELMoney30K += resDate.GTEL_30000_MONEY;

          this.report.MKHACMoney30K +=
            resDate.VNMB_30000_MONEY +
            resDate.GTEL_30000_MONEY;
          console.log(resDate.Date + ": PROCESSED Money30K!");

          // MONEY 20K
          this.report.VTELMoney20K += resDate.VTEL_20000_MONEY;
          this.report.MOBIMoney20K += resDate.MOBI_20000_MONEY;
          this.report.VINAMoney20K += resDate.VINA_20000_MONEY;
          this.report.VNMBMoney20K += resDate.VNMB_20000_MONEY;
          this.report.GTELMoney20K += resDate.GTEL_20000_MONEY;

          this.report.MKHACMoney20K +=
            resDate.VNMB_20000_MONEY +
            resDate.GTEL_20000_MONEY;
          console.log(resDate.Date + ": PROCESSED Money20K!");
          // TOTAL
          this.report.TIMECount += resDate.Total;

          this.report.TIMEMoney30K +=
            resDate.VTEL_30000_MONEY +
            resDate.MOBI_30000_MONEY +
            resDate.VINA_30000_MONEY +
            resDate.VNMB_30000_MONEY +
            resDate.GTEL_30000_MONEY;

          this.report.TIMEMoney20K +=
            resDate.VTEL_20000_MONEY +
            resDate.MOBI_20000_MONEY +
            resDate.VINA_20000_MONEY +
            resDate.VNMB_20000_MONEY +
            resDate.GTEL_20000_MONEY;

          console.log(resDate.Date + ": PROCESSED TimeMoney!");
          // WEB / SMS
          for (const oCarrier of this.arrCarrier) {
            for (const oAward of this.arrAward) {

              this.report.TIMEWEB +=
                resDate["WEB_" + oAward + "_" + oCarrier];

              this.report.TIMESMS +=
                resDate["SMS_" + oAward + "_" + oCarrier];

              this.report.TIMEWEB_Money +=
                resDate["WEB_" + oAward + "_" + oCarrier + "_MONEY"];

              this.report.TIMESMS_Money +=
                resDate["SMS_" + oAward + "_" + oCarrier + "_MONEY"];
            }
          }

          console.log(resDate.Date + ": PROCESSED Time Web/SMS!");
          resDate.MKHAC = resDate.VNMB + resDate.GTEL;

          ChartData.cate.push(resDate.Date.substring(0, 5));
          ChartData.data.push(resDate.Value.toString());

          this.TBLdata.push(resDate);
          console.log(resDate.Date);
        }
        // this.report.VTELCount += resDate.VTEL_30000 + resDate.VTEL_20000;
        // this.report.MOBICount += resDate.MOBI_30000 + resDate.MOBI_20000;
        // this.report.VINACount += resDate.VINA_30000 + resDate.VINA_20000;
        // this.report.MKHACCount += resDate.VNMB_30000 + resDate.VNMB_20000 + resDate.GTEL_30000 + resDate.GTEL_20000;
        // this.report.VNMBCount += resDate.VNMB_30000 + resDate.VNMB_20000;
        // this.report.GTELCount += resDate.GTEL_30000 + resDate.GTEL_20000;
        // // console.log(this.report.VTELCount);
        // let VTEL_30000 = resDate.VTEL_30000 * MONEY_DISCOUNT.VTEL_30000;
        // let MOBI_30000 = resDate.MOBI_30000 * MONEY_DISCOUNT.MOBI_30000;
        // let VINA_30000 = resDate.VINA_30000 * MONEY_DISCOUNT.VINA_30000;
        // let VNMB_30000 = resDate.VNMB_30000 * MONEY_DISCOUNT.VNMB_30000;
        // let GTEL_30000 = resDate.GTEL_30000 * MONEY_DISCOUNT.GTEL_30000;

        // let VTEL_20000 = resDate.VTEL_20000 * MONEY_DISCOUNT.VTEL_20000;
        // let MOBI_20000 = resDate.MOBI_20000 * MONEY_DISCOUNT.MOBI_20000;
        // let VINA_20000 = resDate.VINA_20000 * MONEY_DISCOUNT.VINA_20000;
        // let VNMB_20000 = resDate.VNMB_20000 * MONEY_DISCOUNT.VNMB_20000;
        // let GTEL_20000 = resDate.GTEL_20000 * MONEY_DISCOUNT.GTEL_20000;
        // this.report.TIME30K += resDate.VTEL_30000 + resDate.MOBI_30000 + resDate.VINA_30000 + resDate.VNMB_30000 + resDate.GTEL_30000
        // this.report.TIME20K += resDate.VTEL_20000 + resDate.MOBI_20000 + resDate.VINA_20000 + resDate.VNMB_20000 + resDate.GTEL_20000
        // resDate["VTEL"] = VTEL_30000 + VTEL_20000;
        // resDate["MOBI"] = MOBI_30000 + MOBI_20000;
        // resDate["VINA"] = VINA_30000 + VINA_20000;
        // resDate["VNMB"] = VNMB_30000 + VNMB_20000;
        // resDate["GTEL"] = GTEL_30000 + GTEL_20000;
        // resDate["MKHAC"] = VNMB_30000 + VNMB_20000 + GTEL_30000 + GTEL_20000;
        // this.report.VTELMoney30K += VTEL_30000;
        // this.report.MOBIMoney30K += MOBI_30000;
        // this.report.VINAMoney30K += VINA_30000;
        // this.report.MKHACMoney30K += VNMB_30000 + GTEL_30000;
        // this.report.VNMBMoney30K += VNMB_30000;
        // this.report.GTELMoney30K += GTEL_30000;

        // this.report.VTELMoney20K += VTEL_20000;
        // this.report.MOBIMoney20K += MOBI_20000;
        // this.report.VINAMoney20K += VINA_20000;
        // this.report.MKHACMoney20K += VNMB_20000 + GTEL_20000;
        // this.report.VNMBMoney20K += VNMB_20000;
        // this.report.GTELMoney20K += GTEL_20000;
        // this.report.TIMECount += resDate.Total;

        // this.report.TIMEMoney30K +=
        //   VTEL_30000 + MOBI_30000 + VINA_30000 + VNMB_30000 + GTEL_30000;

        // this.report.TIMEMoney20K +=
        //   VTEL_20000 + MOBI_20000 + VINA_20000 + VNMB_20000 + GTEL_20000;

        // // console.log(this.report.TIMEMoney30K);
        // // console.log(this.report.TIMEMoney20K);

        // ChartData.cate.push(resDate.Date.substring(0, 5));
        // ChartData.data.push(resDate.Value.toString());
        // this.TBLdata.push(resDate);


        // for (let oCarrier of this.arrCarrier) {
        //   for (let oAward of this.arrAward) {
        //     this.report.TIMEWEB += resDate["WEB_" + oAward + "_" + oCarrier];
        //     this.report.TIMESMS += resDate["SMS_" + oAward + "_" + oCarrier];
        //     this.report.TIMEWEB_Money +=
        //       resDate["WEB_" + oAward + "_" + oCarrier] *
        //       MONEY_DISCOUNT[oCarrier + "_" + oAward];
        //     this.report.TIMESMS_Money +=
        //       resDate["SMS_" + oAward + "_" + oCarrier] *
        //       MONEY_DISCOUNT[oCarrier + "_" + oAward];
        //     // for (let oPaytype of this.arrPaytype) {
        //     //   this.report[oCarrier + "_" + oPaytype+"_MONEY"] +=
        //     //     resDate[oCarrier + "_" + oAward + "_" + oPaytype] * MONEY_DISCOUNT[oCarrier + "_" + oAward]
        //     // }
        //   }
        // }

        //======== PROCESS PERCENT WEB-SMS
        this.report.TIMEWEB_Percent =
          (this.report.TIMEWEB / (this.report.TIMEWEB + this.report.TIMESMS)) *
          100;
        this.report.TIMESMS_Percent = 100 - this.report.TIMEWEB_Percent;
        //Tính Percent
        this.report.VTEL_PREPAID =
          (this.report.VTEL_PREPAID_MONEY /
            (this.report.VTEL_PREPAID_MONEY +
              this.report.VTEL_POSTPAID_MONEY)) *
          100;
        this.report.MOBI_PREPAID =
          (this.report.MOBI_PREPAID_MONEY /
            (this.report.MOBI_PREPAID_MONEY +
              this.report.MOBI_POSTPAID_MONEY)) *
          100;
        this.report.VINA_PREPAID =
          (this.report.VINA_PREPAID_MONEY /
            (this.report.VINA_PREPAID_MONEY +
              this.report.VINA_POSTPAID_MONEY)) *
          100;
        this.report.MKHAC_PREPAID_MONEY = this.report.VNMB_PREPAID_MONEY + this.report.GTEL_PREPAID_MONEY
        this.report.MKHAC_POSTPAID_MONEY = this.report.VNMB_POSTPAID_MONEY + this.report.GTEL_POSTPAID_MONEY
        this.report.MKHAC_PREPAID =
          ((this.report.VNMB_PREPAID_MONEY + this.report.GTEL_PREPAID_MONEY) /
            (this.report.VNMB_PREPAID_MONEY +
              this.report.VNMB_POSTPAID_MONEY + this.report.GTEL_PREPAID_MONEY +
              this.report.GTEL_POSTPAID_MONEY)) *
          100;
        this.report.VTEL_POSTPAID = 100 - this.report.VTEL_PREPAID;
        this.report.MOBI_POSTPAID = 100 - this.report.MOBI_PREPAID;
        this.report.VINA_POSTPAID = 100 - this.report.VINA_PREPAID;
        this.report.MKHAC_POSTPAID = 100 - this.report.MKHAC_PREPAID;
        // this.report.VNMB_POSTPAID = 100 - this.report.VNMB_PREPAID;
        // this.report.GTEL_POSTPAID = 100 - this.report.GTEL_PREPAID;
        this.report.TIMECount_Percent = (this.report.TIMECount / this.$PRJ_CODE_AMOUNT) * 100;

        this.report.TIMEMoney30K_Percent =
          (this.report.TIMEMoney30K /
            (this.report.TIMEMoney30K + this.report.TIMEMoney20K)) *
          100;
        this.report.TIMEMoney20K_Percent =
          (this.report.TIMEMoney20K /
            (this.report.TIMEMoney30K + this.report.TIMEMoney20K)) *
          100;

        this.report.VTELCount_Percent =
          (this.report.VTELCount / this.report.TIMECount) * 100;

        this.report.MOBICount_Percent =
          (this.report.MOBICount / this.report.TIMECount) * 100;

        this.report.VINACount_Percent =
          (this.report.VINACount / this.report.TIMECount) * 100;


        this.report.MKHACCount_Percent =
          ((this.report.VNMBCount + this.report.GTELCount) / this.report.TIMECount) * 100;

        // this.report.GTELCount_Percent =
        //   (this.report.GTELCount / this.report.TIMECount) * 100;

        // console.log(VTEL30K_Count);
        // console.log(MOBI30K_Count);
        // console.log(VINA30K_Count);
        // console.log(VNMB30K_Count);
        // console.log(GTEL30K_Count);

        if (process.env.NODE_ENV === 'development')
          console.log(this.report.VTELMoney30K + this.report.VTELMoney20K);
        this.report.VTELMoney30K_Percent =
          (this.report.VTELMoney30K /
            (this.report.VTELMoney30K + this.report.VTELMoney20K)) *
          100;
        this.report.MOBIMoney30K_Percent =
          (this.report.MOBIMoney30K /
            (this.report.MOBIMoney30K + this.report.MOBIMoney20K)) *
          100;
        this.report.VINAMoney30K_Percent =
          (this.report.VINAMoney30K /
            (this.report.VINAMoney30K + this.report.VINAMoney20K)) *
          100;

        this.report.MKHACMoney30K_Percent =
          ((this.report.VNMBMoney30K + this.report.GTELMoney30K) /
            (this.report.VNMBMoney30K + this.report.GTELMoney30K + this.report.VNMBMoney20K + this.report.GTELMoney20K)) *
          100;
        // this.report.VNMBMoney30K_Percent =
        //   (this.report.VNMBMoney30K /
        //     (this.report.VNMBMoney30K + this.report.VNMBMoney20K)) *
        //   100;
        // this.report.GTELMoney30K_Percent =
        //   (this.report.GTELMoney30K /
        //     (this.report.GTELMoney30K + this.report.GTELMoney20K)) *
        //   100;

        this.report.VTELMoney20K_Percent =
          100 - this.report.VTELMoney30K_Percent;
        this.report.MOBIMoney20K_Percent =
          100 - this.report.MOBIMoney30K_Percent;
        this.report.VINAMoney20K_Percent =
          100 - this.report.VINAMoney30K_Percent;
        this.report.MKHACMoney20K_Percent =
          100 - this.report.MKHACMoney30K_Percent;
        // this.report.VNMBMoney20K_Percent =
        //   100 - this.report.VNMBMoney30K_Percent;
        // this.report.GTELMoney20K_Percent =
        //   100 - this.report.GTELMoney30K_Percent;
        // if (isNaN(this.report[key])) {
        //   console.log(field);
        //   this.report[key] = 0;
        // }
        for (var key in this.report) {
          if (isNaN(this.report[key])) {
            this.report[key] = 0;
          }
        }
        this.options.xaxis.categories = ChartData.cate;
        this.series[0].data = ChartData.data;
      }

      if (process.env.NODE_ENV === 'development')
        console.log(this.report)
      this.isLoading = false;
      // } catch (er) {
      //   this.$message.error("Có lỗi xảy ra trong quá trình lấy dữ liệu!", 5000);
      //   console.log(er.message)
      //   this.isLoading = false;
      // }
    },
    async getPaytype(toDate) {
      this.isLoadingPaid = true;
      try {
        let dataPayType = await this.API_GetDashboard_Paytype(toDate);
        if (dataPayType && dataPayType.data.State == 1) {

          if (process.env.NODE_ENV === 'development')
            console.log(dataPayType);
        }
      } catch (error) {
        this.$message.error(
          "Có lỗi xảy ra trong quá trình lấy dữ liệu Paytype!",
          1500
        );
        console.log("Get Paytype Error:" + error.message);
      }
      this.isLoadingPaid = false;
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
  },
  beforeDestroy() {
    clearInterval(this.Timer);
  },
};
</script>

<style>
.ant-col {
  padding: 1px !important;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

.vm-progress-bar__innerText {
  color: rgba(0, 0, 0, 0.65) !important;
  /* color:red!important; */
}

.vm-progress-bar__striped {
  text-align: left !important;
}

.small {
  max-width: 600px;
  margin: 150px auto;
}

.fish.row .col {
  padding-right: 2px;
}

.vm-progress {
  padding-bottom: 5px;
}

.circlePercent {
  width: 60px;
  height: 60px;
  line-height: 60px;
  border-radius: 50%;
  font-size: 11px;
  border: 3px solid #13ce66;
  text-align: center;
}

.fish.card>.header {
  padding: 0.7em 0.3em !important;
}
</style>
